import { render, staticRenderFns } from "./UiSimpleEditorToolbar.vue?vue&type=template&id=39153be8&scoped=true"
import script from "./UiSimpleEditorToolbar.vue?vue&type=script&lang=ts"
export * from "./UiSimpleEditorToolbar.vue?vue&type=script&lang=ts"
import style0 from "./UiSimpleEditorToolbar.vue?vue&type=style&index=0&id=39153be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39153be8",
  null
  
)

export default component.exports